export default "__VITE_ASSET__D2ZkGTa4__"